export const TipoBeneficio = {
    TELETRABAJO: "TELETRABAJO",
    HORARIO_FLEXIBLE: "HORARIO_FLEXIBLE",
    HORAS_LIBRES: "HORAS_LIBRES"
};